import { PresentationSlide } from '@/modules/presentation/PresentationSlide';
import { PresentationSlideProps } from '@/modules/presentation/PresentationSlide/PresentationSlide';
import { SlideFooterBrandingContext } from '@/modules/presentation/PresentationSlide/SlideFooterBranding.context';

import { useIsDraftPresentation } from '../hooks/useIsDraftPresentation';
import { ClientPresentationFooter } from './ClientPresentationFooter';
import { ClientPresentationRightHeading } from './ClientPresentationHeader';

export interface ClientPresentationSlideProps
  extends Omit<PresentationSlideProps, 'rightHeaderContent'> {
  skipHeader?: boolean;
  skipFooter?: boolean;
}

export function ClientPresentationSlide({
  id,
  skipHeader = false,
  skipFooter = false,
  leftHeaderContent,
  footer = <ClientPresentationFooter slideId={id} />,
  slideDesign,
  ...props
}: ClientPresentationSlideProps) {
  const isDraft = useIsDraftPresentation();

  return (
    <PresentationSlide.Slide
      {...props}
      id={id}
      slideDesign={slideDesign}
      watermark={isDraft ? 'DRAFT' : undefined}
      leftHeaderContent={skipHeader ? undefined : leftHeaderContent}
      rightHeaderContent={
        skipHeader || !leftHeaderContent ? undefined : (
          <ClientPresentationRightHeading />
        )
      }
      footer={
        !skipFooter && footer ? (
          <SlideFooterBrandingContext.Provider value={slideDesign}>
            {footer}
          </SlideFooterBrandingContext.Provider>
        ) : undefined
      }
    />
  );
}
